import { getClient } from '@/lib/restClient';
import { MenuManagementBrandItemService } from '@/services/BrandItem/MenuManagementItemService';

export const useMenuManagementDuplicateBrandItem = async (
  id: string
): Promise<void> => {
  const menuManagementBrandItemService = new MenuManagementBrandItemService(
    getClient()
  );
  return await menuManagementBrandItemService.duplicate(id);
};
